import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import CreditTab from './tabs/CreditTab';
import CashTab from './tabs/CashTab';
import Tabs from './tabs/Tabs';

const tabs = [
    { name: 'Cash', element: <CashTab /> },
    { name: 'Credit Card', element: <CreditTab /> }
]

const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Reconciliation = () => {
    const query = useQuery();
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState<any>(tabs[0])

    useLayoutEffect(() => {
        if (query?.get('type') && query?.get('type') !== activeTab?.name) {
            const findActiveTab = tabs?.find((item) => item?.name === query?.get('type'))
            setActiveTab(findActiveTab || undefined)
        }
    }, [query?.get('type')])

    const onClickTab = (value: any) => {
        setActiveTab(value)
        setSearchParams({})
    }

    useEffect(() => {
        searchParams.set('type', activeTab?.name)
        setSearchParams(searchParams)
    }, [activeTab])

    return (
        <div>
            <div>
                <p className='page-title'>Reconciliation</p>
            </div>
            <Tabs
                activeTab={activeTab.name}
                onClickTab={onClickTab}
                tabs={tabs}
            />
            <div>
                {activeTab?.element}
            </div>
        </div>
    )
}
export default Reconciliation;